export const RESULT_OPERATORS = ['==', '!=', '<', '<=', '>', '>='] as const;

export type ResultOperator = typeof RESULT_OPERATORS[number];

const OPERATOR_VALUE_PATTERN = /^(==|!=|<=|>=|<|>)(.*)$/;

export const parseOperatorValue = (value: string): { operator: ResultOperator; operand: string } => {

  const match = value.match(OPERATOR_VALUE_PATTERN);
  if (!match) {

    return { operator: '==', operand: value };

  }

  return {
    operator: match[1] as ResultOperator,
    operand: match[2],
  };

};

export const formatOperatorValue = (operator: ResultOperator, operand: string): string => `${operator}${operand}`;

export const getDefaultResultFilterValue = (filterKey: string): string | undefined => {

  switch (filterKey) {

  case 'available':
    return '==true';
  case 'distance':
    return '<750';
  case 'contacted':
    return '!=true';
  case 'assetId':
    return '!=%alarmAssetId%';
  default:
    return undefined;

  }

};

export const getComparatorOptions = (): ResultOperator[] => ['<', '<=', '>', '>='];
